import React from 'react';
import { WidgetFooter, WidgetEmpty, formatRange } from './common';

const partLabel = (part) => (part === 'morning' ? 'am' : part === 'afternoon' ? 'pm' : '');

const TeamOutThisWeekWidget = ({ data }) => {
  const days = data.days || [];
  const people = data.people || [];
  return (
    <>
      <div className="mydesk-week">
        {days.map((day) => (
          <div key={day.date} className={`mydesk-day ${day.is_today ? 'is-today' : ''}`}>
            <span className="mydesk-day-name">{day.weekday}</span>
            <span className="mydesk-day-num">{day.day}</span>
            <div className="mydesk-day-people">
              {day.people.map((p) => (
                <span
                  key={`${day.date}-${p.employee_id}`}
                  className={`mydesk-chip-avatar ${p.part !== 'full' ? 'is-half' : ''}`}
                  style={p.color ? { backgroundColor: p.color } : undefined}
                  title={`${p.name}${p.part !== 'full' ? ` (${partLabel(p.part)})` : ''}`}
                >
                  {p.initials}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
      {people.length === 0 && <WidgetEmpty>Everyone on your team is in this week.</WidgetEmpty>}
      {people.length > 0 && (
        <ul className="mydesk-legend">
          {people.map((p) => (
            <li key={p.employee_id}>
              <span className="mydesk-legend-dot" style={p.color ? { backgroundColor: p.color } : undefined} />
              <span className="mydesk-legend-name">{p.employee_name}</span>
              <span className="mydesk-legend-meta">{formatRange(p.start_date, p.end_date)}</span>
            </li>
          ))}
        </ul>
      )}
      <WidgetFooter label="Open team calendar" url={data.url} />
    </>
  );
};

export default TeamOutThisWeekWidget;
